module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NEW YORK AND QUEENS COUNTY RAILWAY")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The largest independent street railway to operate in Queens was the New York and Queens County Railway, which had lines in Long Island City, Woodside, Astoria, Flushing, College Point, North Beach, and Jamaica and served Manhattan via a line over the Queensborough Bridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The New York and Queens County system had expanded to its final size in 1896 when it took over the lines of the original Steinway Railway Company in western Queens. When the Steinway (piano) interests received a franchise to build a railway tunnel under the East River as the New York and Long Island Railway, the New York and Queens County was determined to be the operator. Two of the main conditions were to electrify the line and to operate multiple unit streetcars through the tunnel to a terminal situated just beneath Manhattan’s Grand Central Terminal. Therefore, the company purchased a fleet of 50 heavy, end-door, multiple-unit streetcars in 1906 from J. G. Brill and American Car and Foundry for exclusive use in the tunnel. The cars were of steel construction and were built with heavy motors to overcome the grades leading into and out of the actual tunnels. On September 22, 1907, a single car was operated on the tunnel line, but the trolleys never again used that expensive property. It lay fallow until 1915 when the twin tubes were incorporated in the Interborough Rapid Transit Company’s Flushing rapid transit line. However, for all those years, the New York and Queens County was saddled with those heavy multiple unit (MU) streetcars, which were really much too weighty for the mainly street running of the company and were extremely expensive to operate due to their inordinate appetite for electricity. In 1909, the New York and Queens County finally got its entry into Manhattan via service on the newly opened Queensborough Bridge. Note that the aforementioned Interborough Rapid Transit had a major hand in Queens and Long Island traction, which will be discussed subsequently.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In 1922, the New York and Queens County fell into bankruptcy and was restructured with the former Steinway Railway’s lines becoming independent once again. A reconstituted company, now called the Steinway Lines, ultimately under the stewardship of the Third Avenue Railway, ran mainly in the Long Island City and Astoria area, also taking over the Queensborough Bridge line to Manhattan.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The newly renamed New York and Queens Railway went back to its original size, serving Long Island City, Woodside, Flushing, College Point, and Jamaica with a separate line to the Calvary Cemetery in southwestern Queens. However, one of the main lines that it still operated was the mostly private right-of-way route between Flushing and Jamaica via Kissena Park and Flushing Meadows (more about this line shortly). An oddity about the Borden Avenue line was that after the breakup of the New York and Queens County, the Borden Avenue line was awarded to the New York and Queens Railway. However, there was no track connection to the rest of the system. To gain access to its own Woodside carbarn, the New York and Queens had to petition its former component company, the Steinway Lines, to permit its own cars to travel over Steinway track for carbarn moves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("On June 24, 1930, the huge New York and Queens carbarn at Woodside, which serviced its own cars and those of the Steinway Lines, was destroyed by fire. Lost in the conflagration were 24 of its old wooden deck-roof cars, 10 recently acquired Birney cars, and 13 service cars. Fortunately 12 cars just purchased from upper New York State’s Auburn and Syracuse Railway were outside the building awaiting new livery and were spared. However, the New York and Queens no longer had sufficient cars to cover its service requirements.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Two of New York’s transit operators, the nearby Jamaica Central Railways and the New York City Department of Plant and Structures, were able to supply temporary replacements. In addition, the New York and Queens scoured the used trolley market and quickly came up with a total of 35 cars from such recently abandoned properties as the Interstate Street Railway (Attleboro, Massachusetts), the Muskegon (Michigan) Electric Traction, the Bridgeton and Millville (New Jersey) Street Railway, the Susquehanna Transit Company of Lock Haven, Pennsylvania, and, finally, the recently motorized Jamaica Central Railways. The new equipment changed the image from a bedraggled street railway to that of a relatively modern property, and revenues soon began to reflect that change.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Unfortunately the City of New York had hot eyes for the Jamaica-Flushing line right-of-way, planning to build a network of automobile expressways in Queens with that stretch of track considered to be a major element. By the middle of August 1937, pressure from the City of New York finally forced the New York and Queens to substitute buses for its trolleys and give up its coveted transmeadow right-of-way, thereby eliminating New York City’s only semblance of an in-the-city interurban operation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("By the end of October 1937, the final New York and Queens rail line, the Calvary Cemetery line, converted to buses. The impact of trolley operations in Queens was down to the impoverished Steinway Lines, and even its time was fast coming to a conclusion.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0003.jpg",
      "src": "images/e9781439633861_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Brooklyn Daily Eagle")]), _vm._v(" almanac map shows the fullest extent of the New York and Queens County Railway. The company was later reorganized as the New York and Queens Railway with the former Steinway Railway lines spun off.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0004.jpg",
      "src": "images/e9781439633861_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The St. Louis Car Company built 11 cars in the 280–290 series in 1900 for the New York and Queens County. Most were taken out of service before the June 1930 carbarn fire.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0005.jpg",
      "src": "images/e9781439633861_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("As part of a photographic inventory of its rolling stock, New York and Queens County car No. 177 represented the 100 single-truck open cars in the 130–229 series.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0006.jpg",
      "src": "images/e9781439633861_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A single-truck open car of the New York and Queens County Railway is shown on Lawrence Avenue (now College Point Boulevard), Flushing, on its way across the swamps and meadows to Jamaica.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0007.jpg",
      "src": "images/e9781439633861_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Car No. 290 ran in shuttle service in downtown Long Island City in the pre–World War I period; its destination was the 34th Street ferry terminal linking Queens with Manhattan.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0008.jpg",
      "src": "images/e9781439633861_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In another inventory photograph, the New York and Queens County’s No. 326 poses for the camera. This car series (321–330) was purchased in 1906. In rebuilt form, a few representative cars remained in service until the 1937 end of trolley operation.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0009.jpg",
      "src": "images/e9781439633861_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This product of the Jewett Car Company was delivered in 1910 and cost a whopping $4,214.16. It ran in updated configuration until 1937 when the successor New York and Queens line quit.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0010.jpg",
      "src": "images/e9781439633861_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The New York and Queens County Railway was chosen to operate the first streetcar tunnel between Queens and Manhattan. Because of the long underwater run and steep grades, one requirement was the equipment to be used be of extra heavy construction and have multiple-unit control capability. The 50 cars (series 601–650) built for this service were never used in tunnel service except for unit No. 601, which was only used one day. The heavy equipment, extremely expensive to operate, was ultimately consigned to local lines.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0011.jpg",
      "src": "images/e9781439633861_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The massive construction of the so-called “tunnel cars” shows up in this portrait of unit No. 641. The 600s were used primarily on the line to North Beach. These cars became a drain on the profitability of the New York and Queens County and probably hastened the company’s reorganization.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0012.jpg",
      "src": "images/e9781439633861_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The 301–310 series cars had been rebuilt to “muzzle loaders” (loading and unloading only via the front door) after the New York and Queens Railway inherited them from their original owner, the New York and Queens County Railway.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0013.jpg",
      "src": "images/e9781439633861_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Still in its orange and blue paint scheme, New York and Queens car No. 361 represented the rebuilt version of the 1911-built Jewett series of cars numbered from 341 to 365. It was hard to miss seeing cars with this livery.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0014.jpg",
      "src": "images/e9781439633861_i0014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A later version of paint job shows up on car No. 364, still carrying its “passenger scooper,” a device cleverly design to scoop up any human being who managed to be in the path of a moving trolley car. It really worked.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0015.jpg",
      "src": "images/e9781439633861_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("New York and Queens strikingly painted car No. 313 shares track at the 160th Street Jamaica terminal with Jamaica Central car No. 305. They were not very pretty, but they did pull in the passengers.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0016.jpg",
      "src": "images/e9781439633861_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A string of deck-roofed New York and Queens passenger cars are stuck standing in the snow near the Woodside carbarn. Note that the tracks are completely obliterated by the snow.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0017.jpg",
      "src": "images/e9781439633861_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Car No. 341 was the lowest numbered car in the 341–365 series, and is shown here in its final orange livery.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0018.jpg",
      "src": "images/e9781439633861_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Although the New York and Queens usually used their newest cars on their high-profile Jamaica-Flushing line, it was sometimes necessary to use older cars to cover the runs. Deck roof car No. 322 loads passengers at Main Street in Flushing for the scenic ride to the connecting subway at Jamaica.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0019.jpg",
      "src": "images/e9781439633861_i0019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Many photographs were taken at the College Point ferry in front of the glassed-in restaurant at the right. However, here is a picture showing the ferry terminal itself with the slips at the end of the track.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0020.jpg",
      "src": "images/e9781439633861_i0020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This section of the New York and Queens was disconnected from the main operation and cars were serviced at the New York and Queens’s Woodside barn, reached by a connection via the Steinway Lines.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0021.jpg",
      "src": "images/e9781439633861_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This track map shows the New York and Queens County Railway in 1928 after the reorganization. Note that the long Jamaica-Flushing line was later rebuilt to double track.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0022.jpg",
      "src": "images/e9781439633861_i0022.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The New York and Queens’s Jamaica-Flushing line was often referred to as the city’s backyard interurban line because it ran right behind so many houses on its route. The trip, however, started at the Jamaica terminal at 160th Street, just below Jamaica Avenue, shown here with cars lining up for the voyage.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0023.jpg",
      "src": "images/e9781439633861_i0023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("At a point on Ninetieth Avenue, at a point between Parsons Boulevard and 153rd Street, the line turned north, squeaked between some buildings, and suddenly was on its own single-track private right-of-way.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0024.jpg",
      "src": "images/e9781439633861_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("It then made a slight turn and became two tracks all the way to Flushing. Note the proximity to the fenced-in backyards.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0025.jpg",
      "src": "images/e9781439633861_i0025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Then the track started a descent that led the line to Kissena Park and Flushing Meadows. Here some apartment buildings gave budding trolley fans a bird’s-eye look at the operation.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0026.jpg",
      "src": "images/e9781439633861_i0026.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Homes became farther apart as the narrow right-of-way threaded itself behind some final buildings.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0027.jpg",
      "src": "images/e9781439633861_i0027.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The line, looking now like a light interurban line, made a sweeping turn to the edge of Kissena Meadows.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0028.jpg",
      "src": "images/e9781439633861_i0028.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Deep into Kissena Park, the double-track line made a long turn along the side of Pidgeon Meadow Road.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0029.jpg",
      "src": "images/e9781439633861_i0029.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Two cars meet on the Kissena Park right-of-way.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0030.jpg",
      "src": "images/e9781439633861_i0030.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("At a sylvan spot along the route, two ladies leave their park bench and board a Flushing-bound car.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0031.jpg",
      "src": "images/e9781439633861_i0031.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The car leaves the tree-shaded trolley stop and rolls toward Flushing Meadows.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0032.jpg",
      "src": "images/e9781439633861_i0032.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The orange trolley must have been a bright sight sweeping across snow-covered Kissena Park in December 1936. Trolley service ended within a year, and part of this scene changed forever, as the six-lane Grand Central Parkway was built partially on this site.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0033.jpg",
      "src": "images/e9781439633861_i0033.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The meadow area was quite barren in those days, with just a meandering road to keep the trolley company. It is hard to believe that part of this area became the site for both the 1939–1940 and the 1964–1965 New York World’s Fairs.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0034.jpg",
      "src": "images/e9781439633861_i0034.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The entire image of the Jamaica-Flushing line changed when the snows came. The line became even more picturesque but much less benign.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0035.jpg",
      "src": "images/e9781439633861_i0035.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Near the edge of Flushing, a cemetery marks the beginning of the town.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0036.jpg",
      "src": "images/e9781439633861_i0036.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The line makes a tight turn before entering the trackage on Flushing’s Main Street, which will continue to the terminal.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0037.jpg",
      "src": "images/e9781439633861_i0037.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Car No. 24 carefully wends its way through heavy traffic just before reaching its final destination in Flushing.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0038.jpg",
      "src": "images/e9781439633861_i0038.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("New York and Queens car No. 34 has completed the trip to Flushing and now sits at the intersection of Main Street and Northern Boulevard, awaiting departure of its return trip to Jamaica.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0039.jpg",
      "src": "images/e9781439633861_i0039.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("One of the New York and Queens’s deck-roof cars rests in the street just before entering relay tracks at Main Street and Northern Boulevard. The company preferred to show its more modern face by usually assigning the newer equipment to this route.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0040.jpg",
      "src": "images/e9781439633861_i0040.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The New York and Queens Railway’s long Borden Avenue line ended at the Long Island City yard of the Long Island Rail Road, where such old-timers as No. 361 delivered commuters for further travel.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0041.jpg",
      "src": "images/e9781439633861_i0041.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("New York and Queens car No. 330 had been around since 1906 but was near the end of its career in this 1936 photographic study. Known as the “small Brills,” its family held down some of the routes that required front loading and unloading. Note the lack of rear steps.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0042.jpg",
      "src": "images/e9781439633861_i0042.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Car No. 500 started life as the private car of the line’s president, August Belmont. It later was in use as a private car available for charter. Its final use was as the office of the line’s superintendent.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0043.jpg",
      "src": "images/e9781439633861_i0043.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("New York and Queens car No. 332 was built by the Jewett Car Company in 1910. It was 1 of 10cars in the 331–340 series. These cars were very similar to the small Brills.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0044.jpg",
      "src": "images/e9781439633861_i0044.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The “big Brills” were distinguishable by having a total of 11 windows, compared to the small Brills, which only had 10.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0045.jpg",
      "src": "images/e9781439633861_i0045.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A deck-roof Brill product stands at the ready in the square at Flushing, awaiting the call for a fast trip to Jamaica.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0046.jpg",
      "src": "images/e9781439633861_i0046.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("When the old New York and Queens County Railway emerged from reorganization, the rejuvenated New York and Queens Railway distinguished its new identity by painting its cars a flashy orange and blue color scheme. Small Brill car No. 326 shows off the new livery.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0047.jpg",
      "src": "images/e9781439633861_i0047.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Resplendent in the new flashy livery, New York and Queens car No. 22, an ex–Muskegon Electric Traction Company car, displays its new paint scheme while traversing the Flushing-Jamaica line.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0048.jpg",
      "src": "images/e9781439633861_i0048.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Even the lowly single-truck Birneys were anointed with the blue and orange paint scheme of the new company. Apparently the new image did not catch on in spite of adapting two-thirds of the official colors of the city of New York. Here car No. 44 scuttles down the street near the Woodside carbarn.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0049.jpg",
      "src": "images/e9781439633861_i0049.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("After a disastrous carbarn fire destroyed a goodly percentage of its rolling stock, the New York and Queens embarked on a buying spree to reequip its system with good secondhand cars. One of its first purchases was a fleet of six utilitarian double-truck cars from Muskegon, Michigan. Now numbered in the 21–26 series, car No. 26 shows off in a portrait at the College Point terminal.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0050.jpg",
      "src": "images/e9781439633861_i0050.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Car Nos. 31–33, 37, and 38 came from the Interstate Street Railway of Attleboro, Massachusetts. Here Interstate car No. 114 is shown being delivered to the New York and Queens.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0051.jpg",
      "src": "images/e9781439633861_i0051.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Now the property of the New York and Queens Railway, car No. 32 was originally operated by Attleboro’s Interstate Street Railway. Posing in the noonday sun at College Point terminus, the car gleams with pride.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0052.jpg",
      "src": "images/e9781439633861_i0052.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The New York and Queens Railway’s carbarn, shops, and yard at Woodside, Queens, was a center of traction activity for years. After the destructive fire of June 24, 1930, the entire west portion of the carbarn was destroyed together with a great deal of rolling stock. The former structure was utilized as an outdoor storage yard until the end of Steinway Lines’s service in 1939, Steinway being the last lessee to use the property.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0053.jpg",
      "src": "images/e9781439633861_i0053.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A general view of the storage yard in 1937 shows cars of three different companies. At the far left, against the wall, are cars of the New York and Queens, in the central portion are some convertible cars used in Steinway Lines service, and at the right are derelict cars of the former Jamaica Central Railways.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0054.jpg",
      "src": "images/e9781439633861_i0054.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Snow in Queens was never fun for the streetcar companies. Here snow sweeper No. 05 of the New York and Queens Railway is temporarily stalled in the snow on Northern Boulevard. The sweeper was formerly the property of the Jamaica Central Railways.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0055.jpg",
      "src": "images/e9781439633861_i0055.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This image shows what is probably sweeper No. 7, purchased by the New York and Queens from the Poughkeepsie and Wappingers Falls Railway of Poughkeepsie, doing its thing on Northern Boulevard at Woodside.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0056.jpg",
      "src": "images/e9781439633861_i0056.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Snow sweeper No. 7 sits behind a New York and Queens passenger car in front of the New York and Queens Woodside carbarn.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0057.jpg",
      "src": "images/e9781439633861_i0057.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Snow sweeper No. 05 clears the way for a passenger car running on Northern Boulevard near Main Street in downtown Flushing.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0058.jpg",
      "src": "images/e9781439633861_i0058.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The New York and Queens County Railway fielded this little beauty: car No. 1, a sprinkler car whose sole purpose in life was to spray water to keep the summer dust down on the dirt streets carrying the railway’s trolley tracks.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0059.jpg",
      "src": "images/e9781439633861_i0059.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The New York and Queens’s original fleet of 12 Birney cars was decimated in the 1930 carbarn fire. Only two cars, Nos. 400 and 411, were not destroyed. The New York and Queens then purchased four replacement Birneys from the Susquehanna Transit Company of Lock Haven, Pennsylvania, in 1932. Survivor car No. 411 bobbles down Main Street, Flushing, in 1936.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0060.jpg",
      "src": "images/e9781439633861_i0060.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("To have a ready source of spare parts, the New York and Queens bought the entire fleet of Birneys from the defunct Jamaica Central Railways. The cars were never put in service but remained in the Woodside yard, chocked up on wooden blocks.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0061.jpg",
      "src": "images/e9781439633861_i0061.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Downtown Flushing certainly looked metropolitan in December 1936 with the streetcars adding a touch of permanence. However, within a year, the trolleys were gone forever.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0062.jpg",
      "src": "images/e9781439633861_i0062.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The area around any carbarn was always typified by the overwhelming supply of trolley wire powering tracks leading to the building. The Woodside barn was an excellent example of the trade. Car No. 5, a former Auburn and Syracuse Railway (Auburn) car, has just emerged from the web.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633861_i0063.jpg",
      "src": "images/e9781439633861_i0063.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Borden Avenue line was originally operated by sister company New York and North Shore Railway. However, during the New York and Queens County Railway reorganization, the line reverted to the new New York and Queens Railway. Car No. 19, thirdhand from the recently defunct Jamaica Central Railways, is eagerly awaiting some boarding passengers.")])])])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03798d12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633861_c01.vue
// module id = 75
// module chunks = 0